import { useEffect, useState, useCallback } from 'react';

const useClickOutside = (ref, callback) => {
  const [executeCallback, setExecuteCallback] = useState(true);

  const handleClick = useCallback(
    e => {
      if (executeCallback && ref.current && !ref.current.contains(e.target)) {
        callback(executeCallback);
      }
    },
    [callback, executeCallback, ref]
  );

  useEffect(() => {
    document.addEventListener('click', handleClick, true);

    return () => document.removeEventListener('click', handleClick, true);
  }, [executeCallback, handleClick]);

  return { setExecuteCallback };
};

export default useClickOutside;
